export class StoreCategoriesResponse {
    limit: number;
    offset: number;
    resultCount: number;
    results?: (StoreCategoriesResultEntity)[] | null;
    sortBy: string;
    sortOrder: string;
}

export class StoreCategoriesResultEntity {
    description: string;
    storeCategoryId: number;
    storeCategoryName: string;
    checked: boolean;
}
